import { LoadablePaint } from '@confluence/loadable';

export const LazyAssignRolesPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AssignRolesPage" */ '../src/PermissionsTransition/assign-roles/AssignRolesPage'
			)
		).AssignRolesPage,
});
